/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export var errorObject = { e: {} };
//# sourceMappingURL=errorObject.js.map



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/internal/util/errorObject.js
// module id = 58
// module chunks = 2